// extracted by mini-css-extract-plugin
module.exports = {"LiveChatButtonContainer":"LiveChatButton_LiveChatButtonContainer__3r8TS","LiveChatButton":"LiveChatButton_LiveChatButton__32czH","TextStripe":"LiveChatButton_TextStripe__12ia7"};